export const CommonUrlParams = {
  withCommonExpiredMessage: "wcem",
};
